import SmoothScroll from 'smooth-scroll';

export const initSmoothScroll = () => {
  const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
    easing: 'easeInOutCubic',
    updateURL: false
  });
};